import React, { useState, useEffect } from "react";

import ResponsiveAppBar from "../../../layouts/navbar";

import CustomDialog from "../../../components/custom/dialog";
import { Footer } from "../../../layouts/footer";
import { ProductTypes } from "../landingPage/components/productTypes";
import { OfferProducts } from "./components/bannerOffer";
import { FilterProducts } from "./components/filterProduct";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../app/redux/hooks";
import { getProductListWithCategoryAsync } from "../../../../app/slices/productList/productListingSlice";
import { setSelectProduct } from "../../../../app/slices/productDiscriptionSlice/ProductDescriptionSlice";
import { QuickAddModal } from "./components/quickAdd/quickAdd";
import {
  addToWisshListAsync,
  removeFromWishListAsync,
} from "../../../../app/slices/wishlistSlice/wishlistSlice";
import { CircularProgress } from "@mui/material";
import { showSnackbar } from "../../../../app/slices/common/customSnackBar/customSnackbarSlice";

export const ProductListingPage = () => {
  const [modalType, setModalType] = useState("");
  const [filteredProducts, setFilteredProducts] = useState<any>([]);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const category: any = location.pathname.split("/").pop();
  const [priceRange, setPriceRange] = React.useState<[any, any]>([0, 5000]);
  const [vegNonveg, setVegNonveg] = React.useState<string[]>([]);
  const [tags, setTags] = React.useState<string[]>([]);
  const [dynamicFilters, setDynamicFiters] = React.useState<string[]>([]);
  const { productsList } = useAppSelector((state) => state.ProductsListState);

  useEffect(() => {
    if (productsList?.data) {
      setFilteredProducts(productsList?.data);
      priceAndVegnonVegFilter(productsList?.data, priceRange, vegNonveg);
    }
  }, [productsList]);

  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onCloseModal = () => {
    setModalType("");
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const aId = localStorage.getItem("aId");
    const accessToken = localStorage.getItem("accessToken");
    const anonymous_id = accessToken ? null : aId || null;
    const hasFilters =
      (tags && tags.length > 0) ||
      (dynamicFilters && dynamicFilters.length > 0);

    if (hasFilters || category) {
      const payload: any = {
        category_code: category,
        ...(tags?.length && { tag_ids: tags }),
        ...(dynamicFilters?.length && { dynamic_filter_ids: dynamicFilters }),
        ...(anonymous_id && { anonymous_id }),
      };
      dispatch(getProductListWithCategoryAsync(payload));
    }
  }, [category, dynamicFilters, tags]);

  const selectProduct = (id: any) => {
    dispatch(setSelectProduct(id));
    localStorage.setItem("product_id", id);
  };
  const handleAddToWishList = (productId: any) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      const updatedProducts = filteredProducts.map((item: any) => {
        return {
          ...item,
          products: item.products.map((product: any) => {
            if (product.product_id === productId) {
              return {
                ...product,
                wishlist: true,
              };
            }
            return product;
          }),
        };
      });
      setFilteredProducts(updatedProducts);
      addToWishList(productId);
    } else {
      dispatch(
        showSnackbar({
          message: "Please login to create wishlist",
          severity: "error",
          autoHide: 2000,
        })
      );
    }
  };

  const handleRemoveFromWishList = (productId: any) => {
    const updatedProducts = filteredProducts.map((item: any) => {
      return {
        ...item,
        products: item.products.map((product: any) => {
          if (product.product_id === productId) {
            return {
              ...product,
              wishlist: false,
            };
          }
          return product;
        }),
      };
    });

    setFilteredProducts(updatedProducts);
    removeFromWishList(productId);
  };
  const addToWishList = (id: any) => {
    dispatch(addToWisshListAsync(id));
  };
  const removeFromWishList = (id: any) => {
    dispatch(removeFromWishListAsync(id));
  };
  const handleFilterChange = (filters: {
    priceRange: any;
    vegNonveg: string[];
    dynamicFilters: any[];
    tags: any[];
  }) => {
    const { priceRange, dynamicFilters, vegNonveg, tags } = filters;
    setPriceRange(priceRange);
    setDynamicFiters(dynamicFilters);
    setVegNonveg(vegNonveg);
    setTags(tags);
  };
  useEffect(() => {
    priceAndVegnonVegFilter(productsList?.data, priceRange, vegNonveg);
  }, [priceRange, vegNonveg]);

  const priceAndVegnonVegFilter = (
    product: any,
    priceRange: number[],
    vegNonveg: string[]
  ) => {
    const filtered = product
      .map((subcategory: any) => {
        const filteredProducts = subcategory.products.filter((product: any) => {
          const price = parseFloat(product.price);
          const isInPriceRange =
            price >= priceRange[0] && price <= priceRange[1];
          const isTypeMatch =
            vegNonveg.length > 0
              ? vegNonveg.includes(product.product_type)
              : true;

          return isInPriceRange && isTypeMatch;
        });

        return {
          ...subcategory,
          products: filteredProducts,
        };
      })
      .filter((subcategory: any) => subcategory.products.length > 0);

    setFilteredProducts(filtered);
  };

  const handleSort = (sortType: string) => {
    const sortedData = productsList?.data?.map((subcategory: any) => {
      const sortedProducts = [...subcategory.products];

      switch (sortType) {
        case "alphabeticalAsc":
          sortedProducts.sort((a, b) =>
            a.product_name.localeCompare(b.product_name)
          );
          break;

        case "alphabeticalDesc":
          sortedProducts.sort((a, b) =>
            b.product_name.localeCompare(a.product_name)
          );
          break;

        case "priceAsc":
          sortedProducts.sort(
            (a, b) => parseFloat(a.price) - parseFloat(b.price)
          );
          break;

        case "priceDesc":
          sortedProducts.sort(
            (a, b) => parseFloat(b.price) - parseFloat(a.price)
          );
          break;

        default:
          break;
      }

      return {
        ...subcategory,
        products: sortedProducts,
      };
    });

    setFilteredProducts(sortedData);
  };
  const percentageDisplay = (offer: any) => {
    if (!offer) {
      return null;
    }
    const percentage = parseFloat(offer.replace("%", ""));

    const formattedPercentage =
      percentage % 1 === 0
        ? `${Math.round(percentage)}%`
        : `${percentage.toFixed(2)}%`;

    return formattedPercentage;
  };
  return (
    <>
      <div id="wrapper">
        <ResponsiveAppBar />
        <ProductTypes />
        <section className="flat-spacing-1 pt_0 pb_0">
          <div
            className="tf-grid-layout md-col-2 tf-img-with-text style-2"
            style={{
              fontFamily: "Albert Sans, sans-serif",
            }}
          >
            <div className="tf-image-wrap wow fadeInUp" data-wow-delay="0s">
              <img
                className="lazyload"
                data-src="/images/collection-59.jpg"
                src="/images/collection-59.jpg"
                alt="collection-img"
              />
            </div>
            <div className="tf-content-wrap wow fadeInUp" data-wow-delay="0s">
              <div style={{ fontSize: "30px" }} className="heading">
                Create you own perfect Cake
              </div>
              <Link to={`/customOrders`} className="title link">
                <span className="tf-btn style-2 btn-fill rounded-full animate-hover-btn">
                  Click to Customize
                </span>
              </Link>
            </div>
          </div>
        </section>
        {category === "Cak01" && (
          <div className="tf-page-title">
            <div className="container-full">
              <div className="row">
                <div className="col-12">
                  <div className="heading text-center">Cakes</div>
                  <p className="text-center text-2 text_white mt_5">
                    Shop through our latest selection of Cakes
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        <section className="flat-spacing-1">
          {productsList?.loader ? (
            <div className="container">
              <div className="tf-shop-control grid-2 align-items-center justify-content-between">
                <div style={{ minHeight: "50vh" }}>
                  <CircularProgress
                    style={{
                      position: "absolute",
                      // top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="tf-shop-control grid-2 align-items-center justify-content-between">
                <div className="tf-control-filter">
                  <span
                    onClick={() => onOpenModal("filter")}
                    className="tf-btn-filter"
                  >
                    <span className="icon icon-filter"></span>
                    <span className="text">Filter</span>
                  </span>
                </div>
                <div className="tf-control-sorting d-flex justify-content-end">
                  <div className="tf-dropdown-sort" data-bs-toggle="dropdown">
                    <div className="btn-select">
                      <span className="text-sort-value">Sort By</span>
                      <span className="icon icon-arrow-down"></span>
                    </div>
                    <div className="dropdown-menu">
                      {/* <div className="select-item active">
                      <span className="text-value-item">Featured</span>
                    </div>
                    <div className="select-item">
                      <span className="text-value-item">Best selling</span>
                    </div> */}
                      <div
                        className="select-item"
                        onClick={() => handleSort("alphabeticalAsc")}
                      >
                        <span className="text-value-item">
                          Alphabetically, A-Z
                        </span>
                      </div>
                      <div
                        className="select-item"
                        onClick={() => handleSort("alphabeticalDesc")}
                      >
                        <span className="text-value-item">
                          Alphabetically, Z-A
                        </span>
                      </div>

                      <div
                        className="select-item"
                        onClick={() => handleSort("priceAsc")}
                      >
                        <span className="text-value-item">
                          Price, low to high
                        </span>
                      </div>
                      <div
                        className="select-item"
                        onClick={() => handleSort("priceDesc")}
                      >
                        <span className="text-value-item">
                          Price, high to low
                        </span>
                      </div>
                      {/* <div className="select-item">
                      <span className="text-value-item">Date, old to new</span>
                    </div>
                    <div className="select-item">
                      <span className="text-value-item">Date, new to old</span>
                    </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <section className="flat-spacing-1 pt_0 flat-seller">
                {filteredProducts.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      {item?.products?.length > 0 && (
                        <>
                          <div
                            className="flat-title"
                            style={{ paddingTop: index === 0 ? "0px" : "70px" }}
                          >
                            <span
                              className="title wow fadeInUp"
                              data-wow-delay="0s"
                            >
                              {item?.subcategory_name}
                            </span>
                          </div>
                          <div data-wow-delay="0s" data-grid="grid-5">
                            {" "}
                            {item?.products?.map((product: any, index: any) => {
                              return (
                                <div
                                  key={index}
                                  className="card-product fl-item"
                                >
                                  <div className="card-product-wrapper">
                                    {" "}
                                    <Link
                                      to={`/products/${product?.product_id}`}
                                    >
                                      <span
                                        className="product-img"
                                        onClick={() =>
                                          selectProduct(product?.product_id)
                                        }
                                      >
                                        <img
                                          className="lazyload img-product"
                                          data-src={`${process.env.REACT_APP_API_URL}${product?.product_img}`}
                                          src={`${process.env.REACT_APP_API_URL}${product?.product_img}`}
                                          alt="image-product"
                                        />
                                        <img
                                          className="lazyload img-hover"
                                          data-src={`${process.env.REACT_APP_API_URL}${product?.product_img}`}
                                          src={`${process.env.REACT_APP_API_URL}${product?.product_img}`}
                                          alt="image-product"
                                        />
                                      </span>
                                    </Link>
                                    <div className="list-product-btn">
                                      <a
                                        onClick={() => {
                                          onOpenModal("quickAdd");
                                          selectProduct(product?.product_id);
                                        }}
                                        className="box-icon bg_white quick-add tf-btn-loading"
                                      >
                                        <span className="icon icon-bag"></span>
                                        <span className="tooltip">
                                          Quick Add
                                        </span>
                                      </a>

                                      <span
                                        className="box-icon bg_white wishlist btn-icon-action"
                                        onClick={() => {
                                          if (product?.wishlist !== true) {
                                            handleAddToWishList(
                                              product?.product_id
                                            );
                                          } else {
                                            handleRemoveFromWishList(
                                              product?.product_id
                                            );
                                          }
                                        }}
                                      >
                                        {product?.wishlist !== true ? (
                                          <span className="icon icon-heart"></span>
                                        ) : (
                                          <span className="icon icon-delete"></span>
                                        )}

                                        <span className="tooltip">
                                          {product?.wishlist !== true
                                            ? "Add to Wishlist"
                                            : "Remove from Wishlist"}
                                        </span>
                                      </span>
                                    </div>
                                    <div className="on-sale-wrap text-end">
                                      {product?.offer &&
                                        product.offer !== "0%" && (
                                          <div className="on-sale-item">
                                            OFF{" "}
                                            {percentageDisplay(product?.offer)}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-end">
                                    <div className="card-product-info">
                                      <Link
                                        to={`/products/${product.product_id}`} // Link to product description
                                        className="title link"
                                      >
                                        <span
                                          onClick={() =>
                                            selectProduct(product?.product_id)
                                          }
                                        >
                                          {product?.product_name}
                                        </span>
                                      </Link>
                                    </div>
                                    <div className="variant-picker-item">
                                      <div className="variant-picker-values">
                                        <input
                                          id="values-veg"
                                          type="radio"
                                          name="color1"
                                          checked
                                          readOnly
                                        />
                                        <label
                                          className={`hover-tooltip  ${
                                            product?.product_type === "Veg"
                                              ? "veg"
                                              : "nonveg"
                                          }`}
                                          htmlFor="values-veg"
                                          data-value="Veg"
                                        >
                                          <span
                                            className={`btn-checkbox    ${
                                              product?.product_type === "Veg"
                                                ? "bg-color-veg bg-veg"
                                                : "bg-color-nonveg "
                                            }`}
                                          ></span>
                                          <span className="tooltip">
                                            {product?.product_type}
                                          </span>
                                        </label>{" "}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tf-product-info-price mt-1">
                                    <div className="price fs-14 fw-6">
                                      {product?.offerprice}
                                    </div>
                                    <div className="compare-at-price fs-14">
                                      {product?.offer &&
                                        product.offer !== "0%" && (
                                          <span>{product?.price}</span>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          {item?.products?.length > 10 && (
                            <div className="tf-pagination-wrap view-more-button text-center">
                              <button className="tf-btn-loading tf-loading-default style-2 btn-loadmore">
                                <span className="text">Load more</span>
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
                {filteredProducts.length === 0 ? (
                  <div
                    style={{
                      fontSize: "18px",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span className="title wow fadeInUp" data-wow-delay="0s">
                      No data found
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </section>
            </div>
          )}
        </section>
        <div className="row pt_0">
          <div className="col-12">
            <Link to={`/customOrders`} className="title link">
              <span>
                <img
                  src="/images/customize_your_cake.png"
                  className="img-fluid"
                  alt=""
                />
              </span>
            </Link>
          </div>
        </div>
        {/* <OfferProducts /> */}
        <Footer />{" "}
      </div>{" "}
      <CustomDialog
        component={
          <FilterProducts
            filterInputs={productsList?.filters}
            onFilterChange={handleFilterChange}
          />
        }
        title="Filter"
        openDialog={modalType === "filter"}
        handleCloseDialog={onCloseModal}
        modalPlace="left"
      />
      <CustomDialog
        component={<QuickAddModal modalType={modalType} />}
        title="Quick Add"
        openDialog={modalType === "quickAdd"}
        handleCloseDialog={onCloseModal}
        modalPlace="center"
      />
    </>
  );
};
